module.exports = __webpack_public_path__ + "img/first-univ-bg.a9968909.jpg";